import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import Index from "../pages/Index/index";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Glass from "@/pages/Glass";
import ProductVedio from "@/pages/ProductVedio";
import ProductCustomize from "@/pages/ProductCustomize";
import SpaceCustomize from "@/pages/SpaceCustomize";
import BrandIntro from "@/pages/BrandIntro";
import BrandVideo from "@/pages/BrandVideo";
import Culture from "@/pages/Culture";
import Development from "@/pages/Development";
import Dynamic from "@/pages/Dynamics";
import Contact from "@/pages/Contact"; 
import Search from "@/pages/Detail";
import Detail from "@/pages/Dynamics/detail";
import TeaAppreciation from '@/pages/TeaAppreciation';
import BeautyAnalysis from '@/pages/BeautyAnalysis';
import Recruitment from '@/pages/Recruitment';
import SecurityCheck from '@/pages/SecurityCheck';

export default function home(props) {
  return (
    <Fragment>
      <Header />
      <Switch>
        <Route path="/" exact={true} component={Index} />
        <Route path="/product_vedio" component={ProductVedio} />
        <Route path="/product/:id" component={Glass} />
        <Route path="/product_customize" component={ProductCustomize} />
        <Route path="/space_customize" component={SpaceCustomize} />
        <Route path="/brand_intro" component={BrandIntro} />
        <Route path="/brand_video" component={BrandVideo} />
        <Route path="/culture" component={Culture} />
        <Route path="/development" component={Development} />
        <Route exact path="/dynamic" component={Dynamic} />
        <Route exact path="/dynamic/detail/:id" component={Detail} />
        <Route path="/contact" component={Contact} />
        <Route path="/search" component={Search} />
        <Route path="/recruitment" component={Recruitment} />
        <Route exact path="/tea_appreciation" component={TeaAppreciation} />
        <Route exact path="/tea_appreciation/detail/:id" component={Detail} />
        <Route exact path="/beauty_analysis" component={BeautyAnalysis} />
        <Route exact path="/beauty_analysis/detail/:id" component={Detail} />
        <Route exact path="/securityCheck" component={SecurityCheck} />
      </Switch>
      <Footer />
    </Fragment>
  );
}
